<template lang="pug">
AppSidebar(
  :visible="visible"
  @close="close"
)
  AppTabs(compact)
    AppTab(label="Filters")
      .row(v-if="showMembersFilter")
        TimeEntriesMemberFilter.col-sm-12.basic-filters(within-sidebar)
      .row(v-if="!removedUser")
        TimeEntriesProjectFilter.col-sm-12.basic-filters
      .row
        TimeEntriesTimeTypeFilter.col-sm-12.basic-filters
      .row
        TimeEntriesClientTypeFilter.col-sm-12.basic-filters
      .row
        TimeEntriesActivityLevelFilter.col-sm-12.basic-filters
      .row(v-if="showTimeZoneFilter")
        TimeEntriesTimeZoneFilter.col-sm-12.basic-filters

      .mt-auto
        AppButton(
          block
          @click="clearFilters"
        ) Clear filters
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import TimeEntriesTimeZoneFilter from './TimeEntriesTimeZoneFilter.vue';
import select2DropdownParentMixin from '~/mixins/Select2DropdownParent';

export default {
  name: 'TimeEntriesFilterSidebar',
  components: { TimeEntriesTimeZoneFilter },
  mixins: [select2DropdownParentMixin],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    showMembersFilter: {
      type: Boolean,
      default: true,
    },
    showTimeZoneFilter: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['tableColumns', 'removedUser']),
  },
  methods: {
    ...mapActions(['updateTableColumns']),
    close() {
      this.$emit('close');
    },
    clearFilters() {
      this.updateTableColumns({ ...this.tableColumns, show_source: false });
      this.$store.dispatch('clearFilters');
    },
  },
};
</script>
